export enum ChannelIds {
    Android = 'AW',

    IOS = 'IW',

    WC = 'WC',
}
